import { useEffect, useState } from "react";

import { decoColumns } from "./misc/deco-columns";
import size from "lodash/size";
import useAxios from "@hooks/use-axios";
import { useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

const useSegments = () => {
    const { axiosInstance, loading, cancelAllRequests } = useAxios({ base: "panel", initialLoader: true });
    const [data, setData] = useState({ segments: [], pagination: {} });
    const [queryParams, setQueryParams] = useState({});
    const { getSearchParams, deleteParams } = useSearchParams();
    const [modalConfig, setModalConfig] = useState({ isOpen: false, row: {} });
    const { createSearchParams } = useSearchParams();
    const segmentId = getSearchParams("id");
    const { platformId } = useParams();

    const handleModalConfig = (row = {}) => {
        if (size(row)) {
            createSearchParams("id", row._id);
        }
        setModalConfig((prev) => ({ row, isOpen: !prev.isOpen }));
        if (modalConfig.isOpen) {
            deleteParams(["id"]);
        }
    };
    
    const getSegments = async () => {
        const { data } = await axiosInstance.get(`/segments/${platformId}`, {
            params: {
                page : getSearchParams("page"),
                limit: getSearchParams("limit")
            }
        });
        setData({
            segments  : data.data,
            pagination: data.pagination
        });
    };

    const handleRowActions = async (row, action) => {
        if (action === "delete") {
            await axiosInstance.delete(`/segments/${platformId}/${row._id}`);
            getSegments();
            return;
        }
        handleModalConfig(row);
    };

    useEffect(() => {
        const fetchAndOpenSegment = async () => {
            if (segmentId && !modalConfig.isOpen) {
                const { data } = await axiosInstance.get(`/segments/${segmentId}`);
                setModalConfig({ isOpen: true, row: data });
            
            }
        };
        fetchAndOpenSegment();
    }, [segmentId, modalConfig.isOpen]);

    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getSegments();
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams]);

    return {
        data,
        loading,
        columns: decoColumns({ handleRowActions }),
        setQueryParams,
        handleModalConfig,
        modalConfig,
        getSegments
        
    };
};

export default useSegments;